import { CommonModule, NgClass } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Compiler,
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    Input,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { BasicObject, ModalCloseData } from '../../models/services.interface';
import { ModalService } from '../../services/modal.service';

@Component({
    selector: 'checkout-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['modal.component.scss'],
    standalone: true,
    imports: [NgClass, CommonModule],
})
export class ModalComponent implements AfterViewInit {
    @ViewChild('insertionComp', {
        read: ViewContainerRef,
    })
    insertionComp: ViewContainerRef;
    @Input() customModalFooter: TemplateRef<any>;
    @Input() title: string;
    public component;

    public modalRef: ModalService;

    componentRef: ComponentRef<any>;
    params: BasicObject;
    outputs: BasicObject;
    standAlone: boolean = false;
    closeActive: boolean = true;
    backdropClickActive: boolean = true;

    @Input('modalSize') modalSize: string = '';

    constructor(
        private resolver: ComponentFactoryResolver,
        private cdRef: ChangeDetectorRef,
        public compiler: Compiler,
    ) {}

    ngAfterViewInit(): void {
        this.insertionComp.clear();
        const factory = this.resolver.resolveComponentFactory(this.component);
        this.componentRef = this.insertionComp.createComponent(factory);

        this.componentRef.instance.modalRef = this.modalRef;

        for (const paramKey in this.params) {
            this.componentRef.instance[paramKey] = this.params[paramKey];
        }

        if (this.componentRef.instance['title']) {
            this.title = this.componentRef.instance['title'];
        }

        if (!this.customModalFooter && this.componentRef.instance['customModalFooter']) {
            this.customModalFooter = this.componentRef.instance['customModalFooter'];
        }

        for (const paramKey in this.outputs) {
            this.componentRef.instance[paramKey].subscribe((event) => {
                this.outputs[paramKey](event);
            });
        }
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        if (this.insertionComp) {
            this.insertionComp.clear();
        }
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    closeClicked(data: ModalCloseData = { crossClicked: true }): void {
        this.modalRef.close(data);
    }

    backdropClicked(): void {
        if (this.backdropClickActive) {
            this.closeClicked({ backdropClicked: true });
        }
    }
}
